import { useEffect, useState } from "react";


function InputCustom({ title, onChange, value, error }) {

    const [text, setText] = useState(value)

    const action = (value) => {
        setText(value)
        onChange(value)
    }

    useEffect(() => {
        setText(value ?? "");
    }, [value]);

    return (
        <>
            <div className={error ? 'my-2' : 'my-4'}>
                <input
                    value={text}
                    onChange={(e) => action(e.target.value)}
                    className={`text-right p-1 w-72 ${error ? 'border-red-500 ' : 'border-slate-200'} border rounded focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500`}
                />
                <label className="w-40 text-sm text-right text-slate-500 inline-block"> : {title} </label>
            </div>
            {error && (
                <p className="text-red-500 text-xs rtol text-left">{error}</p>
            )}
        </>
    )
}
export default InputCustom;